import UserAvatarPlaceholder from "@/assets/images/user_avatar_placeholder.png";
import UserAvatarPlaceholderDark from "@/assets/images/user_avatar_placeholder_dark.png";
import {themeModeAtom} from "@/store/jotaiAtoms";
import {useAtomValue} from "jotai";
import {useMedia} from "react-use";

export const useUserAvatarPlaceholder = () => {
  const mode = useAtomValue(themeModeAtom);
  const prefersDark = useMedia("(prefers-color-scheme: dark)", false);
  const isDark = mode === "dark" || (mode === "system" && prefersDark);

  return isDark ? UserAvatarPlaceholderDark : UserAvatarPlaceholder;
};
